export default "__VITE_ASSET__BWSlz$7s__"